import React, { useState } from 'react';
import './CodeBlock.css';

export default function CodeBlock({ code = '', language = 'python' }) {
  const [copied, setCopied] = useState(false);
  const copy = () => { navigator.clipboard.writeText(code); setCopied(true); setTimeout(() => setCopied(false), 1800); };
  return (
    <div className="cb">
      <div className="cb__header">
        <div className="cb__dots"><span className="cb__dot cb__dot--r"/><span className="cb__dot cb__dot--y"/><span className="cb__dot cb__dot--g"/></div>
        <span className="cb__lang">{language}</span>
        <button className="cb__copy" onClick={copy}>{copied ? '✓ copied' : 'copy'}</button>
      </div>
      <pre className="cb__pre"><code>{code}</code></pre>
    </div>
  );
}
